import workforce from './widgets/workforce';
import chronicConditions from './widgets/ChronicConditions';
import absenteeism from './widgets/Absenteeism';
import healthOfficeVisits from './widgets/HealthOfficeVisits';
import statesTable from './widgets/StatesTable';

export default [workforce, chronicConditions, absenteeism, healthOfficeVisits, statesTable];
